'use client';

import { createContext, useContext, ReactNode } from 'react';

interface CategoryContextValue {
  categoryCode: string;
}

const CategoryContext = createContext<CategoryContextValue | null>(null);

export const CategoryProvider = ({ children, categoryCode }: { children: ReactNode; categoryCode: string }) => {
  return <CategoryContext.Provider value={{ categoryCode }}>{children}</CategoryContext.Provider>;
};

export const useCategoryCode = () => {
  const context = useContext(CategoryContext);
  if (!context) {
    throw new Error('useCategoryCode must be used within a CategoryProvider');
  }
  return context.categoryCode;
};
